export const saveFile = async (url: string, filename: string) => {
  try {
    // Сначала получаем файл через fetch
    const response = await fetch(url);
    const blob = await response.blob();

    // Создаем URL для blob
    const blobUrl = URL.createObjectURL(blob);

    // Создаем ссылку для скачивания
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || 'file-name';
    a.style.display = 'none';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Освобождаем память
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Ошибка при скачивании файла:', error);
    // Fallback к старому методу
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'file-name';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};

export const downloadByBinaryString = (data: Blob, filename: string) => {
  const blobUrl = URL.createObjectURL(data);
  saveFile(blobUrl, filename);
};
